import React from 'react';

import { AutoComplete, Flex, Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { useDebounce } from '@app/services/hooks/useDebounce';

import { IProps } from '../../interfaces';

import { PARTY_SUGGEST_DEBOUNCE_MS } from './constants';
import { usePartySuggestQuery } from './hooks';
import { getPartyOptions } from './services';

export const PartySuggestInput: React.FC<IProps> = ({ value, onChange, disabled }) => {
  const commonT = useTranslation(NSKeys.common);
  const [search, setSearch] = React.useState('');
  const query: string = useDebounce(search.trim(), PARTY_SUGGEST_DEBOUNCE_MS);
  const suggestions = usePartySuggestQuery(query);

  const options = getPartyOptions(suggestions.data?.suggestions || []);

  return (
    <AutoComplete
      value={value}
      options={options}
      filterOption={false}
      onSearch={setSearch}
      onChange={(inn) => onChange?.(inn)}
      placeholder={commonT.t('partySearchPlaceholder')}
      disabled={disabled}
      notFoundContent={suggestions.isFetching ? <Spin size="small" /> : null}
      optionRender={({ data: { suggestion } }) => (
        <Flex vertical style={{ whiteSpace: 'normal' }}>
          <Typography.Text>{suggestion.value}</Typography.Text>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {commonT.t('inn')}: {suggestion.data.inn}
          </Typography.Text>
          {suggestion.data.address?.value && (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {suggestion.data.address.value}
            </Typography.Text>
          )}
        </Flex>
      )}
    />
  );
};
